export default {
  methods: {
    isSignedIn (gapi) {
      try {
        return gapi.isSignedIn.get()
      } catch (err) {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/checkSignInGmail.js